module.exports = __webpack_public_path__ + "static/media/home-care-card-4.36c8169e.png";